import { render, staticRenderFns } from "./ToolsFormTransverseTraction.vue?vue&type=template&id=09bace00&scoped=true"
import script from "./ToolsFormTransverseTraction.vue?vue&type=script&lang=js"
export * from "./ToolsFormTransverseTraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bace00",
  null
  
)

export default component.exports